var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ProductRowBig',{attrs:{"list":_vm.params.list,"limit":_vm.params.limit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }